const buildFoldersNestingLevelMap = (folders) => {
  const foldersById = new Map(folders.map((folder) => [folder.id, folder]));
  const nestingLevelMap = {};

  const getLevel = (folder) => {
    if (nestingLevelMap[folder.id]) {
      return nestingLevelMap[folder.id];
    }

    const parent = folder.parentFolderId ? foldersById.get(folder.parentFolderId) : null;
    const level = parent ? getLevel(parent) + 1 : 1;

    nestingLevelMap[folder.id] = level;
    return level;
  };

  folders.forEach(getLevel);

  return nestingLevelMap;
};

export default buildFoldersNestingLevelMap;
